export enum ApiVersionEnum {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3'
}
